import { translate } from "@/i18n";
import { desktopVoiceMessages } from "@/i18n/messages/desktop-voice";

/** What a voice preview says, in the app language, so the preview sounds the
 *  way replies will: each sentence is spoken by a voice of its language. */
export function voicePreviewLine(): string {
  return translate(desktopVoiceMessages, "previewLine");
}
